import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import { EmailPreviewContainer } from './EmailPreview/EmailPreviewContainer';
import { Dialog } from '../shared/Dialog';
import { Send } from 'lucide-react';

interface EmailModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const EmailModal: React.FC<EmailModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      size="xl"
    >
      <div className="bg-white/95 backdrop-blur-xl rounded-3xl border border-white/20 shadow-[0_8px_40px_rgba(0,0,0,0.12)] overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-100 flex items-center space-x-4">
          <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-primary-50 to-primary-100 flex items-center justify-center shadow-[0_0_12px_rgba(0,0,0,0.03)]">
            <Send className="w-4 h-4 text-primary-600" />
          </div>
          <div>
            <h1 className="text-lg font-semibold text-gray-900 tracking-tight">
              {t('email.sendInvoice')}
            </h1>
          </div>
        </div>

        <EmailPreviewContainer onEmailSent={onClose} />
      </div>
    </Dialog>
  );
};

export default EmailModal; 